import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { CnRating, CnSelector, CnInputTextArea, CnIcon, CnButton, CnResult, } from '@alife/cn-ui';
import UrlParser from 'fast-url-parser';
import { useSetState } from 'ahooks';
import { useMonitorHistory } from 'src/hooks';
import { saveLightSurvey } from 'src/services';
import { matchPageByUrl } from 'src/utils';
import { useI18n } from '@alife/panda-i18n';
import './index.scss';
import { logCustom } from 'src/utils/tracker';
const matchPage = (pages) => {
    const pathname = location.pathname;
    // return true;
    const includesPage = pages?.filter((p) => {
        p.pathname = UrlParser.parse(p?.pageUrl || '').pathname;
        // @ts-ignore
        return matchPageByUrl(p?.pageUrl, pathname);
    });
    return includesPage;
};
/**
 * 入口管理
 * @returns
 */
export function LightSurveyEntry(props) {
    const { list, config, tempLightSurveyData, currentConfig } = props;
    const changeNextRef = useRef();
    const [state, setState] = useSetState({
        prevConfig: null,
        currentConfig: null,
        data: [],
        title: '',
        submitUrl: '',
        visible: false,
        overIdUrlMap: {},
    });
    const autoCloseSuccess = useRef();
    const closeTempLightSurvey = () => {
        if (tempLightSurveyData) {
            props?.closeLightSurveyData?.(null);
            setState({
                data: [],
                title: '',
                visible: false,
            });
            return;
        }
    };
    const onPageChange = useCallback(() => {
        if (tempLightSurveyData) {
            closeTempLightSurvey();
        }
        let currentPage;
        const obj = list?.filter((it) => {
            // 匹配所有页面
            const res = matchPage(it.targetPageConfigList);
            // 过滤掉所有的 完成轻调研的页面
            const noShowPageList = res?.filter((page) => !state.overIdUrlMap[`${it.id}-${page.pageUrl}`]);
            if (!noShowPageList.length)
                return false;
            // 找到目标页面
            noShowPageList.forEach((page) => {
                const { hostname } = UrlParser.parse(page.pageUrl);
                if (hostname === location.hostname && page.pathname === location.pathname) {
                    currentPage = page;
                }
            });
            return !!noShowPageList?.length;
        })[0];
        // 20s之后 在目标页面展示
        if (obj && currentPage) {
            return setTimeout(() => {
                changeNextRef.current = () => {
                    const title = obj.title;
                    const data = obj.surveyConfig?.questionConfigList;
                    if (autoCloseSuccess.current) {
                        clearTimeout(autoCloseSuccess.current);
                    }
                    setState((state) => ({
                        data,
                        title,
                        visible: true,
                        submitUrl: currentPage?.pageUrl,
                        prevConfig: state.currentConfig,
                        currentConfig: obj,
                    }));
                };
                changeNextRef.current();
            }, 20000);
        }
        // 页面切换后立马清除上一个页面的轻调研
        setState({
            data: [],
            title: '',
            submitUrl: '',
            visible: false,
            prevConfig: null,
            currentConfig: null,
        });
    }, [state, tempLightSurveyData]);
    useEffect(() => {
        // 轻调研数据列表变化 触发 轻调研变化
        if (list?.length && !tempLightSurveyData) {
            const flag = onPageChange();
            window.surveyFlag = flag;
            return () => {
                if (flag) {
                    clearTimeout(flag);
                }
            };
        }
        return () => { };
    }, [list]);
    useEffect(() => {
        // 预览状态下 打开轻调研弹窗
        if (tempLightSurveyData) {
            setState({
                visible: true
            });
        }
    }, [tempLightSurveyData]);
    // 监控页面变化
    useMonitorHistory(onPageChange);
    if (!state.visible) {
        return null;
    }
    return (React.createElement("div", { className: 'cn-intelli-assistant-light-survey-entry' },
        React.createElement(LightSurvey, { data: tempLightSurveyData?.list || state.data, isPreview: !!tempLightSurveyData || false, title: tempLightSurveyData?.title || state.title, submitData: {
                panelCode: config?.panelCode,
                surveyId: state.currentConfig?.id,
                language: config?.language,
                userName: config?.userName,
                userId: config?.userId,
                accountType: config?.accountType,
                submitUrl: state.submitUrl,
            }, currentConfig: currentConfig, onSuccess: (id) => {
                if (tempLightSurveyData) {
                    closeTempLightSurvey();
                    return;
                }
                // 标识 当前问卷 已经被 填过了
                setState((state) => ({
                    prevConfig: state.currentConfig,
                    currentConfig: null,
                    data: [],
                    title: '',
                    submitUrl: '',
                    overIdUrlMap: {
                        ...state.overIdUrlMap,
                        [`${id}-${state.submitUrl}`]: 1,
                    },
                }));
                // 自动关闭已经完成的轻调研
                autoCloseSuccess.current = setTimeout(() => {
                    setState({
                        visible: false,
                    });
                    autoCloseSuccess.current = null;
                }, 3000);
            }, onClose: () => {
                setState({
                    visible: false,
                });
            } })));
}
/**
 *
 * @param props 轻调研组件
 * @returns
 */
function LightSurvey(props) {
    const { className = '', title = '', data, isPreview = true, submitData, onClose, } = props;
    const $i18n = useI18n();
    const [state, setState] = useSetState({
        title,
        submitSuccess: false,
        submitLoading: false,
        star: undefined,
        selectedTag: [],
        comment: '',
        data,
    });
    // 内容变化整个 轻调研信息重置
    useEffect(() => {
        setState({
            data,
            title,
            star: undefined,
            selectedTag: [],
            comment: '',
        });
        props.currentConfig && logCustom(`EXP_${props.currentConfig?.panelConfigCode}`, props.currentConfig?.id, props.panelCode);
    }, [data, title]);
    const onSubmit = async () => {
        const data = {
            ...submitData,
            feedbackText: state.comment,
            starRating: state.star,
            labelList: state.selectedTag,
        };
        // console.log('formData', data);
        try {
            if (!isPreview) {
                setState({
                    submitLoading: true,
                });
                await saveLightSurvey(data);
                setState({
                    submitSuccess: true,
                });
            }
            props.onSuccess?.(submitData.surveyId);
        }
        catch (error) {
            console.error(error, '提交轻调研失败');
        }
        finally {
            setState({
                submitLoading: false,
            });
        }
    };
    const dynamicState = useMemo(() => {
        const temp = state.star ? state.data[state.star - 1] : null;
        return temp;
    }, [state.star, state.data]);
    useEffect(() => {
        setState({
            selectedTag: [],
        });
    }, [state.star]);
    return (React.createElement("div", { className: `cn-intelli-assistant-light-survey ${className}` },
        React.createElement("span", { className: 'cn-intelli-assistant-light-survey-close', onClick: onClose },
            React.createElement(CnIcon, { type: 'close' })),
        state.submitSuccess ? (React.createElement(CnResult, { type: 'success', size: "mini", 
            // title="反馈成功"
            subTitle: React.createElement(React.Fragment, null,
                $i18n.get({
                    id: 'YourFeedbackWillBeOfGreat_1542479043',
                    dm: '您的建议对产品体验提升会有很大帮助，',
                }),
                React.createElement("br", null),
                $i18n.get({
                    id: 'ThankYouForYourSupport',
                    dm: '感谢您的支持！',
                })) })) : (React.createElement(React.Fragment, null,
            React.createElement("h3", { className: 'cn-intelli-assistant-light-survey-title' }, state.title),
            React.createElement("div", { className: 'cn-intelli-assistant-light-survey-ratingDiv' },
                React.createElement(CnRating, { className: 'cn-intelli-assistant-light-survey-rating', value: state.star, size: 'large', onChange: (val) => {
                        setState({
                            star: val,
                        });
                    } })),
            React.createElement("p", { className: 'cn-intelli-assistant-light-survey-desc' }, dynamicState?.questionTitle ||
                $i18n.get({
                    id: 'YourFeedbackWillBeOfGreat_1542479043',
                    dm: '您的反馈对产品优化会有很大帮助',
                })),
            state.star ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'cn-intelli-assistant-light-survey-tag-list' },
                    React.createElement(CnSelector, { dataSource: dynamicState?.tagList, value: state.selectedTag, mode: 'multiple', onChange: (value) => {
                            setState({
                                selectedTag: value,
                            });
                        } })),
                React.createElement("div", { className: 'cn-intelli-assistant-light-survey-comment' },
                    React.createElement(CnInputTextArea, { name: 'comment', placeholder: $i18n.get({
                            id: 'MoreFeedbackSuggestions',
                            dm: '更多反馈建议',
                        }), value: state.comment, onChange: (comment) => {
                            setState({
                                comment,
                            });
                        } })),
                React.createElement(CnButton, { type: 'primary', className: 'cn-intelli-assistant-light-survey-submit-btn', onClick: onSubmit, loading: state.submitLoading }, $i18n.get({
                    id: '31255239613091840.CNTM',
                    dm: '提交',
                })))) : null))));
}
export default LightSurvey;
